"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faEye = require("@fortawesome/pro-regular-svg-icons/faEye");

var S = _interopRequireWildcard(require("./styled"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var RowCountPicker = function RowCountPicker(_ref) {
  var _ref$instance = _ref.instance,
      setPageSize = _ref$instance.setPageSize,
      pageSize = _ref$instance.pageSize,
      numberOfRows = _ref.numberOfRows;
  var claims = window.localStorage.getItem('claims');
  var user = claims ? JSON.parse(claims)['id'] : '';

  var onSetPageSize = function onSetPageSize(value) {
    window.localStorage.setItem("".concat(user, "_pageSize"), value);
    setPageSize(value);
  };

  return /*#__PURE__*/_react["default"].createElement(S.RowCountPicker, {
    "data-testid": "rowcount-picker"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faEye.faEye
  }), /*#__PURE__*/_react["default"].createElement("select", {
    value: pageSize,
    className: "result-dropdown mx-2",
    onChange: function onChange(e) {
      return onSetPageSize(e.target.value);
    },
    "data-testid": "result-number-dropdown"
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "10",
    "data-testid": "display-10"
  }, "10"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "25",
    "data-testid": "display-25"
  }, "25"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "50",
    "data-testid": "display-50"
  }, "50"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "100",
    "data-testid": "display-100"
  }, "100"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "1000",
    "data-testid": "display-1000"
  }, "1000")), "entries of ", numberOfRows);
};

var _default = RowCountPicker;
exports["default"] = _default;